<template>
  <div class="rowForm">
    <div class="rowForm-title">
      БОКОВЫЕ СТЕНКИ РЯДА
      <Info>
        Внешние стенки крайних стеллажей ряда
      </Info>
    </div>
    <div class="rowForm-field">
      <Radio
        v-model="side_wall"
        :value="null"
      >
        Нет
      </Radio>
      <br>
      <Radio
        v-model="side_wall"
        value="screen"
        :disabled="!canSideScreen"
      >
        Боковые экраны
      </Radio>
      <br>
      <div class="rowForm-shift">
        Кол-во:
        <input
          v-model="side_wall_count"
          class="rowForm-count"
          type="number"
          :disabled="side_wall !== 'screen'"
        >
        компл.
      </div>
      <div class="rowForm-hint">
        <p>Возможно только при глубине стеллажей 500мм.<br>Экранов в комплекте 2 штуки: правый и левый.</p>
        <p>Можно добавить несколько комплектов. Высота одного экрана 398мм</p>
      </div>
      <Radio
        v-model="side_wall"
        value="wall"
      >
        Стенки
      </Radio>
      <div class="rowForm-shift">
        <Checkbox
          v-model="side_wall_left"
          :disabled="side_wall !== 'wall'"
        >
          Слева
        </Checkbox>
        <br>
        <Checkbox
          v-model="side_wall_right"
          :disabled="side_wall !== 'wall'"
        >
          Справа
        </Checkbox>
      </div>
    </div>
    <button @click="$emit('submit', $data)">
      {{ isNew ? 'Создать' : 'Применить' }}
    </button>
  </div>
</template>

<script>
  import Info from './Info.vue';
  import Radio from './Radio.vue';
  import Checkbox from './Checkbox.vue';

  export default {
    name: 'RowSideForm',
    inject: {
      options: 'options',
    },
    components: {
      Info,
      Radio,
      Checkbox,
    },
    props: {
      data: Object,
      isNew: Boolean,
    },
    data() {
      return {...this.data};
    },
    computed: {
      canSideScreen() {
        return this.data.depth == 500;
      },
    },
  }
</script>

<style scoped>
  .rowForm {
    padding: 32px;
    width: 264px;
    background: #F6F6F6;
  }
  .rowForm-title {
    font-family: Oswald, Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    text-transform: uppercase;
    color: #A7A7A7;
  }
  .rowForm-field {
    margin: 22px 0 30px;
  }
  .rowForm-count {
    margin: 0 9px;
    width: 47px;
    height: 32px;
    text-align: center;
    appearance: textfield;
  }
  .rowForm-hint {
    font-size: 14px;
    color: #A7A7A7;
  }
  .rowForm-hint p {
    font-size: inherit;
    margin: 1em 0;
  }
  .rowForm-shift {
    font-size: 14px;
    margin-left: 32px;
  }
  select {
    margin-top: 10px;
    width: 100%;
  }
</style>
